import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";
import * as appConfig from "appConfig";

import styles from "./BioModal.module.scss";
import { messages } from "../Interviews.messages";
import { useUi, useBlocks } from "@jelly/lesson";

type BioModal2Props = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const BioModal2: React.FC<BioModal2Props> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();
  return (
    <ui.Modal {...props} title={formatMessage(messages.bio2Title)}>
      <div className={styles.slide}>
        <div className={styles.content}>{formatMessage(messages.bio2Description)}</div>
        <div className={styles.image}>
          <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/case/case05/interviews/2.jpg`} />
        </div>
      </div>
    </ui.Modal>
  );
};
